import axios, { getEnv } from '../../../services/api';
import Axios from 'axios';

const CancelToken = axios.CancelToken;

export const PerfilUsuarioService = {
    findAllPerfil: async (method, filters = {}, updateCancel = () => {}) => {
        try {
            const res = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/perfis${method}`,
                
                {
                    cancelToken: new CancelToken(function executor(c) {
                        // An executor function receives a cancel function as a parameter
                        updateCancel(c);
                    }),
                }
            );
            return res.data;
        } catch (error) {
            return error;
        }
    },
    
    findPerfilById: async (idPerfil, filters = {}, updateCancel = () => {}) => {
        try {
            const res = await axios.get(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/perfis/${idPerfil}`,
                
                {
                    cancelToken: new CancelToken(function executor(c) {
                        // An executor function receives a cancel function as a parameter
                        updateCancel(c);
                    }),
                }
            );
            return res.data;
        } catch (error) {
            return error;
        }
    },
    
    findAdministradorById: async (id) => {
        try {
            const res = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/administradores/${id}`);
            return res.data;
        } catch (error) {
            return error;
        }
    },
    findAllLista: async (params, body = {}, source) => {
        try {
            const response = await axios.post(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/administradores/perfil/relatorio`,
                body,
                {
                    params,
                    cancelToken: source?.token,
                }
            );
            return response.data;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada', error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    
    getFilterOptions: async () => {
        try {
            const response = await axios.get(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/nan/atendimentos/opcoes?consulta=true`
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },
    
    searchInput: async (body, params, source) => {
        const response = await axios.post(
            `${await getEnv(
                'REACT_APP_URL_SERVICE'
            )}/v1/atendimentos-sas/tipos/consultar`,
            body,
            {
                params,
                cancelToken: source.token,
            }
        );
        source.cancel('Operação cancelada pelo usuário');
        return response.data;
    },
    
    changeStatus: async (idVersao) => {
        try {
            return await axios.put(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/perfis/${idVersao}/status`
            );
        } catch (error) {
            throw error;
        }
    },
    
    changeStatusUsuario: async (idUser, idPerfil, isAtivo) => {
        try {
            const res = await axios.put(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/administradores/${idUser}/perfil/${idPerfil}/status/${isAtivo}`
            );
            return res;
        } catch (error) {
            return error;
        }
    },
    
    savePerfil: async (body) => {
        const response = await axios.post(
            `${await getEnv('REACT_APP_URL_SERVICE')}/v1/perfis`,
            body
        );
        return response.data;
    },
    
    saveLista: async (body) => {
        const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/administradores/perfil/precadastro`, body);
        return response.data;
    },
    
    
    deletePerfil: async (idPerfil) => {
        try {
            return await axios.delete(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/perfis/${idPerfil}`
            );
        } catch (error) {
            return error;
        }
    },
    
    deleteLista: async (cpf, idUsuario) => {
        try {
            return await axios.delete(
                `${await getEnv(
                    'REACT_APP_URL_SERVICE'
                )}/v1/administradores/${cpf}/perfil/${idUsuario}`
            );
        } catch (error) {
            return error;
        }
    },
    
    updatePerfil: async (payloadUpdate) => {
        try {
            const res = await axios.put(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/perfis`,
                payloadUpdate
            );
            return res;
        } catch (error) {
            return error;
        }
    },
    updateLista: async (payloadUpdate) => {
        return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/administradores/perfil/precadastro`, payloadUpdate);
    },
};
